import { z } from "zod/mini"

export const NonEmptyStringSchema = z.string().check(
	z.refine((s) => s.trim().length > 0, {
		error: () => "The value must be a non-empty string",
	}),
)

export type NonEmptyString = z.infer<typeof NonEmptyStringSchema>
